import CheckoutModal from 'modals/CheckoutModal/CheckoutModal'

export default CheckoutModal
